"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EPSILON = 0.00001;
const shims = {
    // TODO: Re-implement some of these functions natively in Wasm?
    sin: Math.sin,
    cos: Math.cos,
    tan: Math.tan,
    asin: Math.asin,
    acos: Math.acos,
    atan: Math.atan,
    atan2: Math.atan2,
    rand: a => Math.random() * a,
    pow: Math.pow,
    log: Math.log,
    log10: Math.log10,
    exp: Math.exp,
    sigmoid: function (x, y) {
        const t = 1 + Math.exp(-x * y);
        return Math.abs(t) > EPSILON ? 1.0 / t : 0;
    },
};
exports.default = shims;
//# sourceMappingURL=shims.js.map